export const maintenanceConfig = {
  isUnderMaintenance: false,
  maintenanceEndTime: '-',
};